var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlockFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.329102 8.74107C0.329102 8.19099 0.558971 7.66344 0.968141 7.27447C1.37731 6.88551 1.93227 6.66699 2.51092 6.66699H10.1473C10.7259 6.66699 11.2809 6.88551 11.6901 7.27447C12.0992 7.66344 12.3291 8.19099 12.3291 8.74107V13.9263C12.3291 14.4763 12.0992 15.0039 11.6901 15.3928C11.2809 15.7818 10.7259 16.0003 10.1473 16.0003H2.51092C1.93227 16.0003 1.37731 15.7818 0.968141 15.3928C0.558971 15.0039 0.329102 14.4763 0.329102 13.9263V8.74107Z",
    fill: "#7048E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99512 4C2.99512 3.54037 3.08565 3.08525 3.26154 2.66061C3.43743 2.23597 3.69524 1.85013 4.02024 1.52513C4.34525 1.20012 4.73109 0.942313 5.15573 0.766422C5.58037 0.59053 6.03549 0.5 6.49512 0.5C6.95474 0.5 7.40987 0.59053 7.83451 0.766422C8.25915 0.942313 8.64499 1.20012 8.96999 1.52513C9.295 1.85013 9.5528 2.23597 9.7287 2.66061C9.90459 3.08525 9.99512 3.54037 9.99512 4V7H8.99512V4C8.99512 3.33696 8.73173 2.70107 8.26288 2.23223C7.79404 1.76339 7.15816 1.5 6.49512 1.5C5.83208 1.5 5.19619 1.76339 4.72735 2.23223C4.25851 2.70107 3.99512 3.33696 3.99512 4V7H2.99512V4Z",
    fill: "#7048E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockFill);
export default __webpack_public_path__ + "static/media/unlock-fill.f9b3b02676cd92100644e724997cb3ef.svg";
export { ForwardRef as ReactComponent };